import React from 'react';
import { BonusCover } from '../BonusCover';
import { Accent } from './SectionHeading';
import { bonuses } from '../../data/content';

/** Section 10 — extra bonuses, deliberately smaller than the core volumes. */
export function BonusesSection() {
  return <section aria-labelledby="bonus-heading" className="border-t border-brand-plum/10 bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-51" data-mp="16j4wvq3t1epa">
      <div className="mx-auto max-w-6xl" data-id="element-52" data-mp="wms20owiwusy">
        <div className="mx-auto max-w-2xl text-center" data-id="element-53" data-mp="wp5y912xwd23">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-54" data-mp="11n7gjjsjk8ci">
            And There's More
          </p>
          <h2 id="bonus-heading" className="mt-4 font-display text-[2.1rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.75rem]" data-id="element-55" data-mp="nopxhzdkzk0x">
            Get 5 Extra Teaching Resources <Accent data-id="element-56" data-mp="2hyjpyisw7mf4">Included</Accent>
          </h2>
        </div>

        <ol className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" role="list" data-id="element-57" data-mp="2myz61i4k780s">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col rounded-[16px] bg-white p-4 pb-5" data-id="element-58" data-mp="1k5hgj11bld9t">
              <BonusCover label={bonus.number.replace('#', '')} title={bonus.coverTitle} color={bonus.color} className="mx-auto w-full max-w-[150px]" data-id="element-59" data-mp="1txneqsi60qxg" />
              <p className="mt-4 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-plum" data-id="element-60" data-mp="1187tzb0p7joc">
                {bonus.number}
              </p>
              <h3 className="mt-1.5 font-body text-[14px] font-semibold leading-snug text-brand-charcoal lg:min-h-[3.9rem]" data-id="element-61" data-mp="x9qxdlewlrl6">
                {bonus.title}
              </h3>
              <p className="mt-1.5 text-[13px] leading-relaxed text-brand-charcoal/65" data-id="element-62" data-mp="166rfxbfakvgp">{bonus.description}</p>
            </li>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-63" data-mp="2hnr5w0e62y7k">
          The bonuses expand your teaching library.{' '}
          <strong className="font-semibold text-brand-charcoal" data-id="element-64" data-mp="2pq9x3qd0gcbz">
            The 6 professional volumes remain the heart of Makeup Instructor Ready.
          </strong>
        </p>
      </div>
    </section>;
}